import UserLayout from "@/layouts/UserLayout.vue";
import HomeView from "../views/HomeView.vue";
import { RouteRecordRaw } from "vue-router";
import UserRegisterView from "@/views/user/UserRegisterView.vue";
import ACCESS_ENUM from "@/access/accessEnum";
import NoAuthView from "@/views/NoAuthView.vue";
import AdminUserView from "@/views/admin/AdminUserView.vue";
import UserLoginView from "@/views/user/UserLoginView.vue";
import AdminAppView from "@/views/admin/AdminAppView.vue";
import AdminQuestionView from "@/views/admin/AdminQuestionView.vue";
import AdminScoringResultView from "@/views/admin/AdminScoringResultView.vue";
import AdminAnswerQueryView from "@/views/admin/AdminAnswerQueryView.vue";
import AppDetailView from "@/views/app/AppDetailView.vue";
import AddAppView from "@/views/add/AddAppView.vue";
import AddQuestionView from "@/views/add/AddQuestionView.vue";
import AddScoringResultView from "@/views/add/AddScoringResultView.vue";
import AnswerResultView from "@/views/answer/AnswerResultView.vue";
import DoAnswerView from "@/views/answer/DoAnswerView.vue";
import MyAnswerView from "@/views/answer/MyAnswerView.vue";
import AppStatisticView from "@/views/statistic/AppStatisticView.vue";

export const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "主页",
    component: HomeView,
  },
  // add
  {
    path: "/app/detail/:id",
    name: "应用详情",
    component: AppDetailView,
    props: true,
    meta: {
      hideInMenu: true,
    },
  },
  {
    path: "/add/app",
    name: "创建应用",
    component: AddAppView,
  },
  {
    path: "/add/app/:id",
    name: "编辑应用",
    component: AddAppView,
    props: true,
    meta: {
      hideInMenu: true,
    },
  },
  {
    path: "/add/question/:appId",
    name: "创建题目",
    component: AddQuestionView,
    props: true,
    meta: {
      hideInMenu: true,
    },
  },
  {
    path: "/add/scoring_result/:appId",
    name: "创建评分",
    component: AddScoringResultView,
    props: true,
    meta: {
      hideInMenu: true,
    },
  },
  // no auth
  {
    path: "/noAuth",
    name: "无权限",
    component: NoAuthView,
    meta: {
      hideInMenu: true, // 这个路由在菜单中隐藏
    },
  },
  // user
  {
    path: "/user",
    name: "用户",
    component: UserLayout,
    meta: {
      hideInMenu: true, // 这个路由在菜单中隐藏
    },
    children: [
      {
        path: "/user/login",
        name: "登录",
        component: UserLoginView,
      },
      {
        path: "/user/register",
        name: "注册",
        component: UserRegisterView,
      },
    ],
  },
  // admin
  {
    path: "/admin/user",
    name: "用户管理",
    component: AdminUserView,
    meta: {
      access: ACCESS_ENUM.ADMIN,
    },
  },
  {
    path: "/admin/app",
    name: "应用管理",
    component: AdminAppView,
    meta: {
      access: ACCESS_ENUM.ADMIN, // 需要管理员权限才能访问
    },
  },
  {
    path: "/admin/question",
    name: "题目管理",
    component: AdminQuestionView,
    meta: {
      access: ACCESS_ENUM.ADMIN, // 需要管理员权限才能访问
    },
  },
  {
    path: "/admin/scoringResult",
    name: "评分结果管理",
    component: AdminScoringResultView,
    meta: {
      access: ACCESS_ENUM.ADMIN, // 需要管理员权限才能访问
    },
  },
  {
    path: "/admin/answerQuery",
    name: "回答管理",
    component: AdminAnswerQueryView,
    meta: {
      access: ACCESS_ENUM.ADMIN, // 需要管理员权限才能访问
    },
  },
  // answer
  {
    path: "/answer/do/:appId",
    name: "答题",
    component: DoAnswerView,
    props: true,
    meta: {
      hideInMenu: true,
      access: ACCESS_ENUM.USER,
    },
  },
  {
    path: "/answer/result/:id",
    name: "答题结果",
    component: AnswerResultView,
    props: true,
    meta: {
      hideInMenu: true,
      access: ACCESS_ENUM.USER,
    },
  },
  {
    path: "/answer/my",
    name: "我的答题",
    component: MyAnswerView,
    meta: {
      access: ACCESS_ENUM.USER,
    },
  },
  {
    path: "/app_statistic",
    name: "应用统计",
    component: AppStatisticView,
    meta: {
      access: ACCESS_ENUM.ADMIN,
    },
  },
];
